export default __webpack_public_path__ + "static/media/clubhouse.4b73ebd5.png";